// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__2xHla","socialIcons":"footer_socialIcons__2ZYhw"};